import moment from 'moment-timezone';

import { IEmployeeBalanceDTO, IFutureBalanceRequestDTO, ISystemSettingsDTO } from 'src/api/dtos';
import { EmployeeBenefitStatusEnums } from 'src/shared/enums';

export const mapValidateEmployeeBalanceRequest = ({
  isPartialDay,
  absenceTypeId,
  startDate,
  endDate,
  startTime,
  endTime,
}: Partial<IFutureBalanceRequestDTO>): IFutureBalanceRequestDTO => {
  return {
    isPartialDay: !!isPartialDay,
    absenceTypeId: absenceTypeId as number,
    startDate: startDate || '',
    endDate: endDate,
    startTime: startTime ? moment(startTime).format('H:mm:ss') : undefined,
    endTime: endTime ? moment(endTime).format('H:mm:ss') : undefined,
  };
};

export const isBalanceCheckInvalid = (
  balanceCheck: IEmployeeBalanceDTO | null | undefined,
  settings: ISystemSettingsDTO | null,
): boolean => {
  return (
    !!balanceCheck &&
    balanceCheck.status === EmployeeBenefitStatusEnums.VIOLATED &&
    !!settings?.isFutureBalanceViolationBlockEnabled
  );
};
